import React from "react";
import { Link } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import MenuLabel from "../parts/MenuLabel";

const EnergyMenu = ({
  state,
  isPathActive,
  toggleMenuState,
  arrayFeatures,
  navigate,
  userData,
  jobTitle
}) => {
  return (
    <>
      {/* Batch Tracker */}
      {arrayFeatures?.includes("Batch Tracker") && (
        <li className={isPathActive("/batch-tracker") ? "nav-item active" : "nav-item"}>
          <div
            className={state.appsMenuOpen ? "nav-link menu-expanded" : "nav-link"}
            onClick={() => {
              toggleMenuState("appsMenuOpen");
              navigate("/batch-tracker/app");
            }}
          >
            <i className="ti-layout menu-icon"></i>
            <span className="menu-title">Batch Tracker</span>
            <i className="menu-arrow"></i>
          </div>
          <Collapse in={state.appsMenuOpen}>
            <ul className="nav flex-column sub-menu">
              <li className="nav-item">
                <Link
                  className={isPathActive("/batch-tracker/app") ? "nav-link active" : "nav-link"}
                  to="/batch-tracker/app"
                >
                  App
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={isPathActive("/batch-tracker/csv-export") ? "nav-link active" : "nav-link"}
                  to="/batch-tracker/csv-export"
                >
                  CSV Export
                </Link>
              </li>
            </ul>
          </Collapse>
        </li>
      )}

      {/* Production Staging */}
      {arrayFeatures?.includes("Production Staging") && (
        <li className={isPathActive("/staging") ? "nav-item active" : "nav-item"}>
          <div
            className={state.staging ? "nav-link menu-expanded" : "nav-link"}
            onClick={() => {
              toggleMenuState("staging");
              navigate("/staging/app");
            }}
          >
            <i className="ti-folder menu-icon"></i>
            <span className="menu-title">Production Staging</span>
            <i className="menu-arrow"></i>
          </div>
          <Collapse in={state.staging}>
            <ul className="nav flex-column sub-menu">
              <li className="nav-item">
                <Link
                  className={isPathActive("/staging/app") ? "nav-link active" : "nav-link"}
                  to="/staging/app"
                >
                  App
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={isPathActive("/staging/summary") ? "nav-link active" : "nav-link"}
                  to="/staging/summary"
                >
                  Summary Report
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={isPathActive("/staging/csv-export") ? "nav-link active" : "nav-link"}
                  to="/staging/csv-export"
                >
                  CSV Export
                </Link>
              </li>
            </ul>
          </Collapse>
        </li>
      )}

      {/* Receiving */}
      {arrayFeatures?.includes("Receiving") && (
        <li className={isPathActive("/receiving") ? "nav-item active" : "nav-item"}>
          <div
            className={state.receiving ? "nav-link menu-expanded" : "nav-link"}
            onClick={() => {
              toggleMenuState("receiving");
              navigate("/receiving/app");
            }}
          >
            <i className="ti-package menu-icon"></i>
            <span className="menu-title">Receiving</span>
            <i className="menu-arrow"></i>
          </div>
          <Collapse in={state.receiving}>
            <ul className="nav flex-column sub-menu">
              <li className="nav-item">
                <Link
                  className={isPathActive("/receiving/app") ? "nav-link active" : "nav-link"}
                  to="/receiving/app"
                >
                  App
                </Link>
              </li>
              {arrayFeatures?.includes("Receiving Report") && (
                <li className="nav-item">
                  <Link
                    className={isPathActive("/receiving/csv-export") ? "nav-link active" : "nav-link"}
                    to="/receiving/csv-export"
                  >
                    Receiving Report
                  </Link>
                </li>
              )}
              {arrayFeatures?.includes("Backorder Report") && (
                <li className="nav-item">
                  <Link
                    className={isPathActive("/receiving/backorder-report") ? "nav-link active" : "nav-link"}
                    to="/receiving/backorder-report"
                  >
                    <MenuLabel label="Backorder Report" badgeColor="info" badgeText="BETA" />
                  </Link>
                </li>
              )}
            </ul>
          </Collapse>
        </li>
      )}

      {/* Supply Chain Catalog */}
      {arrayFeatures?.includes("Supply Chain Catalog") && (
        <li className={isPathActive("/supply-chain-catalog") ? "nav-item active" : "nav-item"}>
          <div
            className={state.supplyChainCatalog ? "nav-link menu-expanded" : "nav-link"}
            onClick={() => {
              toggleMenuState("supplyChainCatalog");
              navigate("/supply-chain-catalog/search-materials");
            }}
          >
            <i className="ti-layout menu-icon"></i>
            <span className="menu-title">Supply Chain Catalog</span>
            <i className="menu-arrow"></i>
          </div>
          <Collapse in={state.supplyChainCatalog}>
            <ul className="nav flex-column sub-menu">
              {arrayFeatures?.includes("Requisition List") && (
                <li className="nav-item">
                  <Link
                    className={isPathActive("/supply-chain-catalog/requisition-list/material-requisition") ? "nav-link active" : "nav-link"}
                    to="/supply-chain-catalog/requisition-list/material-requisition"
                  >
                    Requisition List
                  </Link>
                </li>
              )}
              {arrayFeatures?.includes("Search Materials") && (
                <li className="nav-item">
                  <Link
                    className={isPathActive("/supply-chain-catalog/search-materials") ? "nav-link active" : "nav-link"}
                    to="/supply-chain-catalog/search-materials"
                  >
                    Search Materials
                  </Link>
                </li>
              )}
            </ul>
          </Collapse>
        </li>
      )}

      {/* Energy-specific items would go here */}
    </>
  );
};

export default EnergyMenu;